/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Files_Active_Filters_NoneInputs */

const es_settings_files_active_filters_none = /** @type {(inputs: Settings_Files_Active_Filters_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin filtros activos`)
};

const en_settings_files_active_filters_none = /** @type {(inputs: Settings_Files_Active_Filters_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No active filters`)
};

/**
* | output |
* | --- |
* | "No active filters" |
*
* @param {Settings_Files_Active_Filters_NoneInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_active_filters_none = /** @type {((inputs?: Settings_Files_Active_Filters_NoneInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Active_Filters_NoneInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_active_filters_none(inputs)
	return en_settings_files_active_filters_none(inputs)
});
export { settings_files_active_filters_none as "settings.files.active_filters.none" }